import { render } from "./CourseCatalog.vue?vue&type=template&id=e913946a"
import script from "./CourseCatalog.vue?vue&type=script&lang=js"
export * from "./CourseCatalog.vue?vue&type=script&lang=js"
script.render = render

export default script